export default __webpack_public_path__ + "static/media/three_of_cups.8ff4440a.png";